export default "__VITE_ASSET__BYAQf3Po__"